import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';
// Group Header
export const InitialGroupHeaderState = {
    name: null,
    code: null
};

export const GroupHeaderSchema = Yup.object().shape({
    name: Yup.string().required(),
    code: Yup.string().required(),
});

export const GroupHeaderFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "code", title: "Code", required: true, type: VALUE_TYPES.TEXT },
];

// Main Group
export const InitialMainGroupState = {
    name: null,
    code: null,
    group_header_id: null,
};

export const MainGroupSchema = Yup.object().shape({
    name: Yup.string().required(),
    code: Yup.string().required(),
    group_header_id: Yup.number().required(),
});

export const MainGroupFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "code", title: "Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "group_header_id", title: "Group Header", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

// Sub Account
export const InitialSubAccountState = {
    name: null,
    code: null,
    main_group_id: null,
};

export const SubAccountSchema = Yup.object().shape({
    name: Yup.string().required(),
    code: Yup.string().required(),
    main_group_id: Yup.number().required()
});

export const SubAccountFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "code", title: "Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "group_header_id", title: "Group Header", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "main_group_id", title: "Main Group", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

// Account
export const InitialAccountState = {
    name: null,
    code: null,
    sub_account_id: null
};

export const AccountSchema = Yup.object().shape({
    name: Yup.string().required(),
    code: Yup.string().required(),
    sub_account_id: Yup.number().required()
});

export const AccountFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "code", title: "Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "group_header_id", title: "Group Header", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "main_group_id", title: "Main Group", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "sub_account_id", title: "Sub Account", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];
